import * as types from 'actions/actionTypes';
import * as services from 'services/apis/google/googleServices';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function getTimezoneRequest(){
    return {type: types.GET_TIMEZONE_REQUEST}
}

export function getTimezoneSuccess(data){
    return {type: types.GET_TIMEZONE_SUCCESS, data}
}

export function getTimezoneError(){
    return {type: types.GET_TIMEZONE_ERROR}
}

/**
 * ricerca unità di misura
 * @param {nome dell'unità di misura} name
 */
export const getTimeZone = (latitude, longitude, timestamp, languageCode) => dispatch => {
    /*
        notifico che sta partendo la richiesta
    */
    dispatch(getTimezoneRequest());
    dispatch(beginAjaxCall());

    // restituisce una promise
    services.getTimeZone(latitude, longitude, timestamp, languageCode)

        .then(response => {
            if (!response.data || response.data.status !== "OK") {
                /*
                    per qualche strano motivo la richiesta è fallita
                */
                dispatch(ajaxCallError());
                dispatch(getTimezoneError());
                return;
            }

            /*
                operazione avvenuta con successo
            */
            var data = {
                dstOffset: response.data.dstOffset,
                rawOffset: response.data.rawOffset
            }
            dispatch(getTimezoneSuccess(data));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getTimezoneError());
    });
}


// WEBPACK FOOTER //
// ./src/actions/googleServicesActions.js